import type { ISiteMetadata } from '@anywayseo/tools';
import { graphql, useStaticQuery } from 'gatsby';


function useSiteMetadata(): ISiteMetadata {
  const data = useStaticQuery(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          title
          description
          siteUrl
          lang
          currency
        }
      }
    }
  `);

  return data.site.siteMetadata;
}

export default useSiteMetadata;
